module.exports = __webpack_public_path__ + "img/img.97e50755.png";